import loadable from "@loadable/component";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";
import usePostHook from "../../customHooks/usePostHook";
import { useEffect, useState } from "react";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { usePDFPrintHook } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
const EditOrderComponent = loadable(
  () => import("../../components/MerchantInvoice/EditConsignment")
);
const EditConsignment = (props: any) => {
  const { id } = props;
  const [openAddReceiverPopup, setOpenAddReceiverPopup] = useState(false);
  const [openAddSenderPopup, setOpenAddSenderPopup] = useState(false);
  const [openPrintPopup, setOpenPrintPopup] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [prevData, setPrevData] = useState();
  const { data: order, isLoading } = useGetHook({
    queryKey: [`order-${id}`],
    url: `${APIS.ORDER}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["order"],
    navigateURL: "",
  });

  const { data: profile } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });

  const { downloadPrint, isPrintLoading } = usePDFPrintHook();
  const handleLabelPrintDownload = async () => {
    const url = `${APIS.ORDER}label-print/`;
    let formData = {
      order_ids: [selectedOrder],
    };
    try {
      await downloadPrint(url, formData);
    } catch (err) {
      console.log(err);
    }
  };

  const handleOrderReceiptDownload = async () => {
    const url = `${APIS.ORDER}order-receipt-print/`;
    let formData = {
      order_ids: [selectedOrder],
    };
    try {
      await downloadPrint(url, formData);
    } catch (err) {
      console.log(err);
    }
  };

  const transformPackageTypeToId = (data: any[]) => {
    return data?.map((item) => ({
      ...item,
      calculated_by: item?.calculated_by?.id,
      package_type: item.package_type.id,
    }));
  };

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.ORDER}${id}/`;
    const formatExtraCharges = (values, prevExtraCharges = {}) => {
      return values?.extra_charges
        ? Object.entries(values.extra_charges)
            .filter(([key, value]) => {
              const prevValue = prevExtraCharges[key] || 0;
              return (
                value !== "" &&
                value !== null &&
                (value !== 0 || prevValue !== 0)
              );
            })
            .map(([key, value]) => ({
              name: key,
              charge: value,
            }))
        : null;
    };
    const prevExtraCharges = order?.extra_charges;
    const formattedArray = formatExtraCharges(values, prevExtraCharges);
    const transformedData = transformPackageTypeToId(values?.order_items);
    let formData = {
      ...values,
      order_items: transformedData,
      sender_phone_number:
        values?.sender_phone_number?.length === 10
          ? `+977${values?.sender_phone_number}`
          : values?.sender_phone_number
          ? values?.sender_phone_number
          : null,
      receiver_phone_number:
        values?.receiver_phone_number?.length === 10
          ? `+977${values?.receiver_phone_number}`
          : values?.receiver_phone_number
          ? values?.receiver_phone_number
          : null,
      extra_charges: formattedArray,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status == 200) {
        setOpenPrintPopup(true);
        setSelectedOrder(id);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (Array.isArray(order?.children)) {
      setPrevData(order?.children);
    }
  }, [order]);

  return (
    <>
     
      {isLoading ? (
        <Spinner />
      ) : (
        <EditOrderComponent
          isLoading={isPatchLoading}
          handleEdit={handleEdit}
          order={order}
          openAddReceiverPopup={openAddReceiverPopup}
          setOpenAddReceiverPopup={setOpenAddReceiverPopup}
          openAddSenderPopup={openAddSenderPopup}
          setOpenAddSenderPopup={setOpenAddSenderPopup}
          openPrintPopup={openPrintPopup}
          setOpenPrintPopup={setOpenPrintPopup}
          profile={profile}
          isPrintLoading={isPrintLoading}
          handleLabelPrintDownload={handleLabelPrintDownload}
          handleOrderReceiptDownload={handleOrderReceiptDownload}
        />
      )}
    </>
  );
};
export default EditConsignment;
